export const GET_PERMISSION_GROUP_SUCCES = 'GET_PERMISSION_GROUP_SUCCESS';
export const GET_PERMISSION_GROUP_FAILED = 'GET_PERMISSION_GROUP_FAILED';
export const GET_PERMISSION_GROUP_REQUEST = 'GET_PERMISSION_GROUP_REQUEST';
